import { render, staticRenderFns } from "./DeliveryWuliuDian.vue?vue&type=template&id=67f81a6a&scoped=true&"
import script from "./DeliveryWuliuDian.vue?vue&type=script&lang=js&"
export * from "./DeliveryWuliuDian.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryWuliuDian.vue?vue&type=style&index=0&id=67f81a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f81a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f81a6a')) {
      api.createRecord('67f81a6a', component.options)
    } else {
      api.reload('67f81a6a', component.options)
    }
    module.hot.accept("./DeliveryWuliuDian.vue?vue&type=template&id=67f81a6a&scoped=true&", function () {
      api.rerender('67f81a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/DeliveryWuliuDian.vue"
export default component.exports